//@flow
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import PontoAtendimentoCrudList from './PontoAtendimentoCrudList';
import PontoAtendimentoEdit from './PontoAtendimentoEdit';
export default class PontoAtendimentoCrud extends React.PureComponent<{}> {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route
            path="/pontoAtendimento"
            exact
            component={PontoAtendimentoCrudList}
          />
          <Route
            path="/pontoAtendimento/novo"
            exact
            component={PontoAtendimentoEdit}
          />
          <Route
            path="/pontoAtendimento/:id"
            component={PontoAtendimentoEdit}
          />
        </Switch>
      </React.Fragment>
    );
  }
}
